import { createFileRoute } from '@tanstack/react-router';

import { AutorizacionesPage } from '@/features/virtual-offices/components/autorizaciones-page';

export const Route = createFileRoute('/_app/virtual-offices/autorizaciones')({
  component: AutorizacionesPage,
});
